import React from 'react';

interface Props {
  error: string | null | undefined;
  onClose: () => void;
}

export default function DismissibleErrorAlert({ error, onClose }: Props) {
  if (!error) {
    return null;
  }

  return (
    <div className="alert alert-danger alert-dismissible" role="alert">
      <button
        type="button"
        className="btn-close"
        aria-label="Close"
        onClick={onClose}
      />
      {error}
    </div>
  );
}
